import { render } from "./PatientDocument.vue?vue&type=template&id=210a1f14&scoped=true"
import script from "./PatientDocument.vue?vue&type=script&lang=js"
export * from "./PatientDocument.vue?vue&type=script&lang=js"

import "./PatientDocument.vue?vue&type=style&index=0&id=210a1f14&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210a1f14"]])

export default __exports__